<div class="publish-date {{themeClass}}" [class.timeline]="isTimeline" *ngIf="category !== 'podcast-lepq' && category !== 'lecons-de-dessin-play'">
  <h1 *ngIf="isHeader; else justDate">
    <app-date [date]="date" [themeClass]="themeClass"></app-date>
  </h1>
  <ng-template #justDate>
    <app-date [date]="date" [themeClass]="themeClass"></app-date>
  </ng-template>
</div>